import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule,  } from '@angular/material/icon';
import {
  NbSpinnerModule,
} from '@nebular/theme';
import {MatLegacyInputModule as MatInputModule} from '@angular/material/legacy-input';
import { FormsModule } from '@angular/forms';
import { LogoSvgComponent } from '../pages/auth/logoSvg/logo.svg.component';
import { NbIconModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

const materialModules = [
  MatIconModule,
  MatInputModule
];

@NgModule({
    imports: [
        CommonModule,
        ...materialModules,
        NbIconModule,
        NbSpinnerModule,
        FormsModule,
        TranslateModule,
        LogoSvgComponent
    ],
    exports: [
        ...materialModules,
        NbSpinnerModule,
        FormsModule,
        LogoSvgComponent,
        TranslateModule,
    ]
})
export class SharedModulesModule { }